export enum SchemaType {
    Product = "product",
    Order = "order",
    Company = "company",
}

export interface Schema {
    id: string;
    name: string;
    type: SchemaType;
    active: boolean;
    generic: boolean;
    composite_key_fields: string[];
    fields: SchemaField[];
}

export enum SchemaFieldType {
    Single = "single",
    Multi = "multi",
}

export enum SchemaFieldSubtype {
    String = "string",
    LongString = "long string",
    Date = "date",
    Lookup = "lookup",
}

export enum SchemaFieldFormatter {
    Uppercase = "uppercase",
    Lowercase = "lowercase",
}

interface SchemaFieldCondition {
    field_reference: string;
    field_values: string[];
}
interface SchemaFieldDetails {
    type: SchemaFieldType;
    subtype: SchemaFieldSubtype;
    formatters: SchemaFieldFormatter[];
    condition: SchemaFieldCondition | null;
    lookup: string;
    allowed_values: { id: string; value: string }[];
    validators: string[];
}

export interface SchemaField {
    id: string;
    name: string;
    key: string;
    display: boolean;
    display_to_buyers: boolean;
    no_default: boolean;
    required: boolean;
    searchable: boolean;
    filterable: boolean;
    unique: boolean;
    image: boolean;
    details: SchemaFieldDetails;
}
